// import React from "react";
// import { InputFactory, InputJson, dialog } from "../../nq-component";
// import {
//   findObjectUseCase,
//   getObjectUseCase,
//   upsertUseCase,
// } from "../../usecases/object";
// import withRouter from "../../withRouter";
// import BaseFormPage from "../../base/BaseFormPage";
// import NavBar from "../../components/navbar";
// import FormFactory from "../../components/FormFactory";
// // import Form1 from "./components/Form1";
// import QAForm1Presenter from "./QAForm1Presenter";
// import Form1 from "./components/Form1";
// import InputAdd from "../../components/InputAdd";
// import Form1Agent from "./components/Form1Agent";
// // import Form1 from "../agent/components/Form1";

// class QAForm1Page extends BaseFormPage {
//   constructor(props) {
//     super(props);
//     this.state = {
//       object: {},
//       advanced: false,
//       type: [],
//       selectedForm: null,
//       reason: "",
//       uploadRelation: [],
//       validationErrors: {
//         natureBusiness: false,
//         operational: false,
//         requesting: false,
//         questions: {},
//       },
//     };
//     this.presenter = new QAForm1Presenter(
//       this,
//       getObjectUseCase(),
//       upsertUseCase()
//     );

//     this.fieldRefs = {
//       natureBusiness: React.createRef(),
//       operational: React.createRef(),
//       requesting: React.createRef(),
//       questions: {},
//     };
//   }

//   componentDidMount() {
//     this.presenter.componentDidMount();
//   }

//   getObjectId() {
//     return this.props.params && this.props.params.id;
//   }

//   getCollectionName() {
//     return "bvr_forms_agent";
//   }

//   onClickAdvance() {
//     this.setState({ advanced: !this.state.advanced });
//   }

//   onChangeObject(object) {
//     this.presenter.onChangeObject(object);
//   }

//   // handleInputChange = (categoryId, value) => {
//   //   const newObject = { ...this.state.object };
//   //   const categoryIndex = newObject.categories.findIndex(
//   //     (c) => c.id === categoryId
//   //   );
//   //   if (categoryIndex !== -1) {
//   //     newObject.categories[categoryIndex].answer = value; // Assuming you want to store the input in 'answer' property
//   //   }
//   //   this.setState({ object: newObject });
//   // };

//   // handleInputChange = (id, value) => {
//   //   console.log("valval", value);
//   //   const newObject = { ...this.state.object };
//   //   // Check if the ID is from categories
//   //   const categoryIndex = newObject.categories.findIndex((c) => c.id === id);
//   //   if (categoryIndex !== -1) {
//   //     newObject.categories[categoryIndex].answer = value;
//   //   } else {
//   //     // If not found in categories, it must be in questions
//   //     newObject.questions.forEach((question) => {
//   //       question.question_per_category.forEach((perCategory) => {
//   //         if (perCategory.id === id) {
//   //           perCategory.answerQuestion = value; // Update specifically the answerQuestion field
//   //         }
//   //       });
//   //     });
//   //   }
//   //   this.setState({ object: newObject });
//   // };

//   // handleInputChange = (id, value, choiceId = null) => {
//   //   console.log("Input Change", value);
//   //   const newObject = { ...this.state.object };
//   //   // Check if the ID is from categories
//   //   const categoryIndex = newObject.categories.findIndex((c) => c.id === id);
//   //   if (categoryIndex !== -1) {
//   //     newObject.categories[categoryIndex].answer = value;
//   //   } else {
//   //     // Check if it's for a choice within a question
//   //     let updated = false;
//   //     newObject.questions.forEach((question) => {
//   //       question.question_per_category.forEach((perCategory) => {
//   //         if (choiceId) {
//   //           // Update the choice name if choiceId is provided
//   //           const choiceIndex = perCategory.choices.findIndex(
//   //             (c) => c.id === choiceId
//   //           );
//   //           if (choiceIndex !== -1) {
//   //             perCategory.choices[choiceIndex].name = value;
//   //             updated = true;
//   //           }
//   //         } else if (perCategory.id === id) {
//   //           // Update the answerQuestion if no choiceId is provided
//   //           perCategory.answerQuestion = value;
//   //           updated = true;
//   //         }
//   //       });
//   //     });
//   //     if (!updated) {
//   //       console.log("No matching IDs found for update.");
//   //     }
//   //   }
//   //   this.setState({ object: newObject });
//   // };
//   handleInputChange = (id, value, choiceId = null) => {
//     console.log("Input Change", value);
//     const newObject = { ...this.state.object };
//     const newValidationErrors = { ...this.state.validationErrors };

//     // Clear validation error when the user starts typing
//     if (newValidationErrors[id]) {
//       newValidationErrors[id] = false;
//     } else if (choiceId && newValidationErrors.questions[choiceId]) {
//       newValidationErrors.questions[choiceId] = false;
//     } else if (newValidationErrors.questions[id]) {
//       newValidationErrors.questions[id] = false;
//     }

//     // Handle top-level input fields
//     if (["natureBusiness", "operational", "requesting"].includes(id)) {
//       newObject[id] = value;
//     } else {
//       // Check if the ID is from categories
//       const categoryIndex = newObject.categories?.findIndex((c) => c.id === id);
//       if (categoryIndex !== -1) {
//         newObject.categories[categoryIndex].answer = value;
//       } else {
//         // Check if it's for a choice within a question
//         let updated = false;
//         newObject.questions?.forEach((question) => {
//           question.question_per_category?.forEach((perCategory) => {
//             if (choiceId) {
//               // Update the choice name if choiceId is provided
//               const choiceIndex = perCategory.choices?.findIndex(
//                 (c) => c.id === choiceId
//               );
//               if (choiceIndex !== -1) {
//                 perCategory.choices[choiceIndex].name = value;
//                 updated = true;
//               }
//             } else if (perCategory.id === id) {
//               // Update the answerQuestion if no choiceId is provided
//               perCategory.answerQuestion = value;
//               updated = true;
//             }
//           });
//         });
//         if (!updated) {
//           console.log("No matching IDs found for update.");
//         }
//       }
//     }
//     this.setState({ object: newObject, validationErrors: newValidationErrors });
//   };

//   validateForm = () => {
//     const object = this.state.object;
//     const requiredFields = ["natureBusiness", "operational", "requesting"];
//     let isValid = true;
//     const validationErrors = {
//       natureBusiness: false,
//       operational: false,
//       requesting: false,
//       questions: {},
//     };

//     // Validate top-level fields
//     for (const field of requiredFields) {
//       if (!object[field]) {
//         validationErrors[field] = true;
//         isValid = false;
//         if (this.fieldRefs[field].current) {
//           this.fieldRefs[field].current.scrollIntoView({ behavior: "smooth" });
//           this.fieldRefs[field].current.focus();
//         }
//       }
//     }

//     // Validate questions and their categories
//     for (const question of object.questions || []) {
//       if (question.questionType === "YES OR NO" && !question.yesOrNo) {
//         if (this.fieldRefs.questions[question.id]) {
//           validationErrors.questions[question.id] = true;
//           isValid = false;
//           this.fieldRefs.questions[question.id].current.scrollIntoView({
//             behavior: "smooth",
//           });
//           this.fieldRefs.questions[question.id].current.focus();
//         }
//       }

//       for (const perCategory of question.question_per_category || []) {
//         if (
//           perCategory.hasOwnProperty("answerQuestion") &&
//           (perCategory.answerQuestion === undefined ||
//             perCategory.answerQuestion === "")
//         ) {
//           if (this.fieldRefs.questions[perCategory.id]) {
//             validationErrors.questions[perCategory.id] = true;
//             isValid = false;
//             this.fieldRefs.questions[perCategory.id].current.scrollIntoView({
//               behavior: "smooth",
//             });
//             this.fieldRefs.questions[perCategory.id].current.focus();
//           }
//         }
//       }
//     }

//     this.setState({ validationErrors });
//     return isValid;
//   };

//   onSubmitForm(e) {
//     e.preventDefault();
//     if (this.validateForm()) {
//       this.presenter.submit();
//     } else {
//       console.log("Validation failed");
//     }
//   }

//   // onSubmitForm(e) {
//   //   e.preventDefault();

//   //   this.presenter.submit();
//   // }

//   onClickStatusQA(index) {
//     this.presenter.onClickStatus(index);
//     dialog.close();
//   }

//   onChangeReason(e) {
//     const value = e.target.value;
//     console.log("val", value);
//     this.setState({ reason: value });
//   }

//   onClickStatusQADis() {
//     dialog.fire({
//       html: (
//         <>
//           <div>
//             <h5 className="text-danger">Disapprove Audit</h5>
//             <div className="col">
//               <h6>Please enter reason of disapproval</h6>
//               <input
//                 className="form-control"
//                 type="text"
//                 onChange={(e) => this.onChangeReason(e)}
//               />
//             </div>
//             <div className="m-3 text-center">
//               <button
//                 className="btn btn-light me-2"
//                 onClick={() => dialog.close()}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="btn btn-danger text-white"
//                 onClick={() => this.onClickStatusQA("Disapprove")}
//               >
//                 Disapprove
//               </button>
//             </div>
//           </div>
//         </>
//       ),
//       footer: false,
//     });
//   }

//   handleImagesChange = (items) => {
//     this.setState((prevState) => ({
//       object: {
//         ...prevState.object,
//         uploadRelation: items,
//       },
//     }));
//   };

//   onChange(value, field) {
//     const newObject = { ...this.state.object }; // Create a copy of the current object
//     newObject[field] = value; // Update the specific field with the new value
//     this.setState({ object: newObject }); // Update the state with the modified object
//   }

//   render() {
//     const object = this.state.object;
//     const validationErrors = this.state.validationErrors;
//     // const { object, validationErrors } = this.state;
//     console.log("objectsss", object);
//     console.log("valid", validationErrors);
//     const advanced = this.state.advanced;
//     const schema = this.getSchema(this.getCollectionName());
//     const user = this.getCurrentUser();
//     if (!schema) return <h1>no schema</h1>;
//     const label = this.getObjectId() === undefined ? "Add New " : "View ";
//     return (
//       <>
//         <NavBar
//           action={() => (
//             <div className="dropdown dropstart d-inline-block">
//               <i
//                 role="button"
//                 data-bs-toggle="dropdown"
//                 className="bi bi-three-dots-vertical"
//               ></i>
//               <div className="dropdown-menu fs-xs">
//                 <button
//                   onClick={this.onClickAdvance.bind(this)}
//                   className="dropdown-item py-3"
//                 >
//                   <i className="bi bi-gear pe-2" />
//                   Toggle Advance
//                 </button>
//               </div>
//             </div>
//           )}
//         />
//         <div className="overflow-auto">
//           <div className="h-100">
//             <div className="p-3 p-lg-4">
//               <div className="row">
//                 <div className="col">
//                   <h1 className="fw-bold mt-3 text-capitalize">
//                     {label + (schema.label || this.getCollectionName())}
//                   </h1>
//                 </div>
//                 {user.roles[0].name === "QA" ? (
//                   <div className="mt-3 col text-end">
//                     <button
//                       className="btn text-white me-2"
//                       style={{ backgroundColor: "#04376a" }}
//                       onClick={() => this.onClickStatusQA("Approved")}
//                     >
//                       APPROVE
//                     </button>
//                     <button
//                       className="btn text-white"
//                       style={{ backgroundColor: "#fdcb5b" }}
//                       onClick={() => this.onClickStatusQADis()}
//                     >
//                       DISAPPROVE
//                     </button>
//                   </div>
//                 ) : null}
//               </div>
//               <div className="d-flex">
//                 <ul className="nav nav-tabs mb-3">
//                   <li className="nav-item">
//                     <a
//                       className="nav-link active"
//                       id="credits-tab"
//                       data-bs-toggle="tab"
//                       href="#credits"
//                       role="tab"
//                       aria-controls="credits"
//                       aria-selected="true"
//                     >
//                       Overview
//                     </a>
//                   </li>
//                   <li className="nav-item">
//                     <a
//                       className="nav-link"
//                       id="logs-tab"
//                       data-bs-toggle="tab"
//                       href="#logs"
//                       role="tab"
//                       aria-controls="logs"
//                       aria-selected="false"
//                     >
//                       Edit Details
//                     </a>
//                   </li>
//                 </ul>
//               </div>
//               <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
//                 <div className="tab-content">
//                   <div
//                     className="tab-pane fade show active"
//                     id="credits"
//                     role="tabpanel"
//                     aria-labelledby="credits-tab"
//                   >
//                     <div className="row g-3">
//                       <Form1Agent
//                         object={object}
//                         onChange={this.handleInputChange}
//                         fieldRefs={this.fieldRefs}
//                         validationErrors={validationErrors}
//                         user={user}
//                         disabled={true}
//                       />
//                       <div>
//                         <label className="mb-2">Remarks</label>
//                         <InputFactory
//                           type="String"
//                           _type="Text"
//                           field="remarks"
//                           object={object}
//                           onChange={this.onChange.bind(this)}
//                         />
//                       </div>
//                       <InputAdd
//                         object={object}
//                         onImagesChange={this.handleImagesChange}
//                         user={user}
//                       />
//                     </div>
//                   </div>
//                   <div
//                     className="tab-pane fade show"
//                     id="logs"
//                     role="tabpanel"
//                     aria-labelledby="logs-tab"
//                   >
//                     <form onSubmit={this.onSubmitForm.bind(this)}>
//                       <div className="row g-3">
//                         <Form1
//                           object={object}
//                           onChange={this.handleInputChange}
//                           fieldRefs={this.fieldRefs}
//                           validationErrors={validationErrors}
//                         />
//                         <div>
//                           <label className="mb-2">Remarks</label>
//                           <InputFactory
//                             type="String"
//                             _type="Text"
//                             field="remarks"
//                             object={object}
//                             onChange={this.onChange.bind(this)}
//                           />
//                         </div>
//                         <InputAdd
//                           object={object}
//                           onImagesChange={this.handleImagesChange}
//                           user={user}
//                         />
//                       </div>
//                       <div className="mt-4">
//                         <button
//                           type="submit"
//                           className="btn btn-primary fs-sm me-3"
//                         >
//                           <i className="bi bi-file-earmark-check me-2"></i>SAVE
//                         </button>
//                         <button
//                           type="button"
//                           className="btn btn-light fs-sm"
//                           onClick={this.onClickBack.bind(this)}
//                         >
//                           GO BACK
//                         </button>
//                       </div>
//                     </form>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </>
//     );
//   }
// }

// export default withRouter(QAForm1Page);

import React from "react";
import { dialog, InputFactory, InputJson } from "../../nq-component";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../usecases/object";
import withRouter from "../../withRouter";
import BaseFormPage from "../../base/BaseFormPage";
import NavBar from "../../components/navbar";

import FormFactory from "../../components/FormFactory";
import Form1 from "./components/Form1";
import InputAdd from "../../components/InputAdd";
// import BusinessForm from "./components/BusinessForm";
import QAForm1Presenter from "./QAForm1Presenter";

class QAForm1Page extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      answer: null,
      activeTab: "overview",
      object: {},
      advanced: false,
      type: [],
      selectedForm: null,
      uploadRelation: [],
      validationErrors: {
        natureBusiness: false,
        operational: false,
        requesting: false,
        questions: {},
      },
      imageRequired: false,
    };
    this.presenter = new QAForm1Presenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );

    // Create refs for each field
    this.fieldRefs = {
      natureBusiness: React.createRef(),
      operational: React.createRef(),
      requesting: React.createRef(),
      questions: {},
    };
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getObjectId() {
    return this.props.params && this.props.params.id;
  }

  getCollectionName() {
    return "bvr_forms_mis";
  }

  getAnswer() {
    return this.state?.answer;
  }

  getAnswerId() {
    return this.props.params.formId;
  }

  getUpload() {
    return this.state.object?.uploadRelation;
  }

  setAnswer(answer) {
    this.setState({ answer });
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }

  handleInputChange = (id, value, choiceId = null) => {
    console.log("Input Change", value);
    const newObject = { ...this.state.object };
    const newValidationErrors = { ...this.state.validationErrors };

    // Clear validation error when the user starts typing
    if (newValidationErrors[id]) {
      newValidationErrors[id] = false;
    } else if (choiceId && newValidationErrors.questions[choiceId]) {
      newValidationErrors.questions[choiceId] = false;
    } else if (newValidationErrors.questions[id]) {
      newValidationErrors.questions[id] = false;
    }

    // Handle top-level input fields
    if (["natureBusiness", "operational", "requesting"].includes(id)) {
      newObject[id] = value;
    } else {
      // Check if the ID is from categories
      const categoryIndex = newObject.categories?.findIndex((c) => c.id === id);
      if (categoryIndex !== -1) {
        newObject.categories[categoryIndex].answer = value;
      } else {
        // Check if it's for a choice within a question
        let updated = false;
        newObject.categories?.forEach((question) => {
          question.questions?.forEach((perCategory) => {
            if (choiceId) {
              // Update the choice name if choiceId is provided
              const choiceIndex = perCategory.choices?.findIndex(
                (c) => c.id === choiceId
              );
              if (choiceIndex !== -1) {
                perCategory.choices[choiceIndex].text = value;
                updated = true;
              }
            } else if (perCategory.id === id) {
              // Update the answerQuestion if no choiceId is provided
              perCategory.answerQuestion = value;
              updated = true;
            }
          });
        });
        if (!updated) {
          console.log("No matching IDs found for update.");
        }
      }
    }
    this.setState({ object: newObject, validationErrors: newValidationErrors });
  };

  validateForm = () => {
    const { object } = this.state;
    console.log("validate object", object);
    const requiredFields = ["natureBusiness", "operational", "requesting"];
    let isValid = true;
    const validationErrors = {
      natureBusiness: false,
      operational: false,
      requesting: false,
      questions: {},
    };

    // Validate top-level fields
    for (const field of requiredFields) {
      if (!object[field]) {
        validationErrors[field] = true;
        isValid = false;
        if (this.fieldRefs[field].current) {
          this.fieldRefs[field].current.scrollIntoView({ behavior: "smooth" });
          this.fieldRefs[field].current.focus();
        }
      }
    }

    if (object?.uploadRelation) {
      for (const item of object.uploadRelation) {
        if (!item.image) {
          isValid = false;

          // validationErrors.uploadRelation = true;
          this.setState({ imageRequired: true });
          break;
        }
      }
    }

    // Validate questions and their categories
    for (const question of object.questions || []) {
      if (question.questionType === "YES OR NO" && !question.yesOrNo) {
        if (this.fieldRefs.questions[question.id]) {
          validationErrors.questions[question.id] = true;
          isValid = false;
          this.fieldRefs.questions[question.id].current.scrollIntoView({
            behavior: "smooth",
          });
          this.fieldRefs.questions[question.id].current.focus();
        }
      }

      for (const perCategory of question.question_per_category || []) {
        if (
          perCategory.hasOwnProperty("answerQuestion") &&
          (perCategory.answerQuestion === undefined ||
            perCategory.answerQuestion === "")
        ) {
          if (this.fieldRefs.questions[perCategory.id]) {
            validationErrors.questions[perCategory.id] = true;
            isValid = false;
            this.fieldRefs.questions[perCategory.id].current.scrollIntoView({
              behavior: "smooth",
            });
            this.fieldRefs.questions[perCategory.id].current.focus();
          }
        }
      }
    }

    this.setState({ validationErrors });
    return isValid;
  };

  onSubmitForm(e) {
    e.preventDefault();
    this.presenter.submit();
    // if (this.validateForm()) {
    //   this.presenter.submit();
    // } else {
    //   console.log("Validation failed");
    // }
  }

  // handleImagesChange = (items) => {
  //   console.log("items hehehe", items);
  //   this.setState((prevState) => ({
  //     answer: {
  //       ...prevState.answer,
  //       uploadRelation: items,
  //     },
  //   }));
  // };
  handleImagesChange = (items) => {
    this.setState((prevState) => ({
      answer: {
        ...prevState.answer,
        uploadRelation: prevState.answer?.uploadRelation?.map(
          (relation, index) => {
            // Check if the image from the updated 'items' array is not empty
            const updatedItem = items[index];
            return {
              ...relation,
              image: updatedItem.image || relation.image, // Retain old image if the new one is empty
            };
          }
        ),
      },
    }));
  };

  onChange(value, field) {
    const newObject = { ...this.state.object }; // Create a copy of the current object
    newObject[field] = value; // Update the specific field with the new value
    this.setState({ object: newObject }); // Update the state with the modified object
  }

  onClickStatusQADis() {
    dialog.fire({
      html: (
        <>
          <div>
            <h5 className="text-danger">Disapprove Audit</h5>
            <div className="col">
              <h6>Please enter reason of disapproval</h6>
              <input
                className="form-control"
                type="text"
                onChange={(e) => this.onChangeReason(e)}
              />
            </div>
            <div className="m-3 text-center">
              <button
                className="btn btn-light me-2"
                onClick={() => dialog.close()}
              >
                Cancel
              </button>
              <button
                className="btn btn-danger text-white"
                onClick={() => this.onClickStatusQA("Disapprove")}
              >
                Disapprove
              </button>
            </div>
          </div>
        </>
      ),
      footer: false,
    });
  }

  onClickStatusQA(index) {
    this.presenter.onClickStatus(index);
    dialog.close();
  }

  onChangeReason(e) {
    const value = e.target.value;
    console.log("val", value);
    this.setState({ reason: value });
  }

  handleTabChange(tabName) {
    this.setState({ activeTab: tabName });
  }

  render() {
    const { object, answer, validationErrors, activeTab } = this.state;
    const user = this.getCurrentUser();
    console.log("object", object);
    console.log("objectAnswer", answer);
    console.log("upload hehe", this.state?.uploadRelation);
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());

    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add New " : "View ";
    return (
      <>
        <NavBar
          action={() => (
            <div className="dropdown dropstart d-inline-block">
              <i
                role="button"
                data-bs-toggle="dropdown"
                className="bi bi-three-dots-vertical"
              ></i>
              <div className="dropdown-menu fs-xs">
                <button
                  onClick={this.onClickAdvance.bind(this)}
                  className="dropdown-item py-3"
                >
                  <i className="bi bi-gear pe-2" />
                  Toggle Advance
                </button>
              </div>
            </div>
          )}
        />
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <div className="row">
                <div className="col">
                  <h1 className="fw-bold mt-3 text-capitalize">
                    {label + (schema.label || this.getCollectionName())}
                  </h1>
                </div>
                {user.roles[0].id === "QA" ? (
                  <div className="">
                    {activeTab === "overview" && (
                      <div
                        className="mt-3 col text-end tab-pane fade show active"
                        id="credits"
                        role="tabpanel"
                        aria-labelledby="credits-tab"
                      >
                        <button
                          className="btn text-white me-2"
                          style={{ backgroundColor: "#04376a" }}
                          onClick={() => this.onClickStatusQA("Approved")}
                        >
                          APPROVE
                        </button>
                        <button
                          className="btn text-white"
                          style={{ backgroundColor: "#fdcb5b" }}
                          onClick={() => this.onClickStatusQADis()}
                        >
                          DISAPPROVE
                        </button>
                      </div>
                    )}
                  </div>
                ) : null}
              </div>
              <div className="d-flex">
                <ul className="nav nav-tabs mb-3">
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      id="credits-tab"
                      data-bs-toggle="tab"
                      href="#credits"
                      role="tab"
                      aria-controls="credits"
                      aria-selected="true"
                      onClick={() => this.handleTabChange("overview")}
                    >
                      Overview
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      id="logs-tab"
                      data-bs-toggle="tab"
                      href="#logs"
                      role="tab"
                      aria-controls="logs"
                      aria-selected="false"
                      onClick={() => this.handleTabChange("logs")}
                    >
                      Edit Details
                    </a>
                  </li>
                </ul>
              </div>

              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <div className="tab-content">
                  <div
                    className="tab-pane fade show active"
                    id="credits"
                    role="tabpanel"
                    aria-labelledby="credits-tab"
                  >
                    <form onSubmit={this.onSubmitForm.bind(this)}>
                      <div className="row g-3">
                        <div>
                          <label className="mb-2">NATURE OF BUSINESS</label>
                          <InputFactory
                            type="String"
                            field="natureBusiness"
                            object={answer}
                            onChange={this.onChange.bind(this)}
                            placeholder="Enter Nature of Business"
                            disabled={true}
                            required
                          />
                        </div>
                        <div>
                          <label className="mb-2">
                            OPERATIONAL DURING VISIT?
                          </label>
                          <InputFactory
                            type="String"
                            field="operational"
                            object={answer}
                            onChange={this.onChange.bind(this)}
                            placeholder="Enter Operational During Visit"
                            disabled={true}
                            required
                          />
                        </div>
                        <div>
                          <label className="mb-2">
                            REQUESTING OFFICER & UNIT
                          </label>
                          <InputFactory
                            type="String"
                            field="requesting"
                            object={answer}
                            onChange={this.onChange.bind(this)}
                            placeholder="Enter Requesting Officer & Unit"
                            disabled={true}
                            required
                          />
                        </div>
                        <Form1
                          object={object}
                          answer={answer}
                          onChange={this.handleInputChange}
                          fieldRefs={this.fieldRefs}
                          validationErrors={validationErrors}
                          user={user}
                          disabled={true}
                        />

                        <div>
                          <label className="mb-2">Remarks</label>
                          <InputFactory
                            type="String"
                            field="remarks"
                            _type="Text"
                            object={answer}
                            onChange={this.onChange.bind(this)}
                            required
                            disabled={true}
                          />
                        </div>

                        <InputAdd
                          object={object}
                          onImagesChange={this.handleImagesChange}
                          user={user}
                          required={this.state.imageRequired}
                          disabled={true}
                          noButton={false}
                        />
                      </div>
                    </form>
                  </div>
                  <div
                    className="tab-pane fade show"
                    id="logs"
                    role="tabpanel"
                    aria-labelledby="logs-tab"
                  >
                    <form onSubmit={this.onSubmitForm.bind(this)}>
                      <div className="row g-3">
                        <div>
                          <label className="mb-2">NATURE OF BUSINESS</label>
                          <InputFactory
                            type="String"
                            field="natureBusiness"
                            object={answer}
                            onChange={this.onChange.bind(this)}
                            placeholder="Enter Nature of Business"
                            required
                          />
                        </div>
                        <div>
                          <label className="mb-2">
                            OPERATIONAL DURING VISIT?
                          </label>
                          <InputFactory
                            type="String"
                            field="operational"
                            object={answer}
                            onChange={this.onChange.bind(this)}
                            placeholder="Enter Operational During Visit"
                            required
                          />
                        </div>
                        <div>
                          <label className="mb-2">
                            REQUESTING OFFICER & UNIT
                          </label>
                          <InputFactory
                            type="String"
                            field="requesting"
                            object={answer}
                            onChange={this.onChange.bind(this)}
                            placeholder="Enter Requesting Officer & Unit"
                            required
                          />
                        </div>
                        <Form1
                          object={object}
                          answer={answer}
                          onChange={this.handleInputChange}
                          fieldRefs={this.fieldRefs}
                          validationErrors={validationErrors}
                          user={user}
                        />

                        <div>
                          <label className="mb-2">Remarks</label>
                          <InputFactory
                            type="String"
                            field="remarks"
                            _type="Text"
                            object={answer}
                            onChange={this.onChange.bind(this)}
                            required
                          />
                        </div>

                        <InputAdd
                          object={answer}
                          onImagesChange={this.handleImagesChange}
                          user={user}
                          required={this.state.imageRequired}
                          noButton={true}
                        />
                      </div>
                      <div className="mt-4">
                        <button
                          type="submit"
                          className="btn btn-primary fs-sm me-3"
                        >
                          <i className="bi bi-file-earmark-check me-2"></i>SAVE
                        </button>
                        <button
                          type="button"
                          className="btn btn-light fs-sm"
                          onClick={this.onClickBack.bind(this)}
                        >
                          GO BACK
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(QAForm1Page);
